import {
  FETCH_COLLECTION_REQUEST,
  FETCH_COLLECTION_SUCCESS,
  FETCH_COLLECTION_FAILURE
} from "../types.js";

const initialState = {
  collections: {}
};

const collectionsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_COLLECTION_REQUEST:
      return {
        ...state,
        collections: {
          ...state.collections,
          [payload.cid]: { ...state.collections[payload.cid], ...payload }
        }
      };
    case FETCH_COLLECTION_SUCCESS:
      return {
        ...state,
        collections: {
          ...state.collections,
          [payload.cid]: { ...state.collections[payload.cid], ...payload }
        }
      };
    case FETCH_COLLECTION_FAILURE:
      console.info("borop cid fail", payload);
      return {
        ...state,
        collections: {
          ...state.collections,
          [payload.cid]: { ...state.collections[payload.cid], ...payload }
        }
      };
    default:
      return state;
  }
};

export default collectionsReducer;
